<template>
  <div class="attr-list">
    <CommonAttr />
    <el-form>
      <el-form-item label="背景颜色">
        <el-color-picker v-model="curComponent.style.background" show-alpha />
      </el-form-item>
      <el-form-item label="切换频率">
        <el-select v-model="curComponent.style.interval">
          <el-option label="5分钟" :value="300000" />
          <el-option label="10分钟" :value="600000" />
          <el-option label="30分钟" :value="1800000" />
          <el-option label="60分钟" :value="3600000" />
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import CommonAttr from '../common/CommonAttr.vue'

export default {
  components: { CommonAttr },
  computed: {
    curComponent() {
      return this.$store.state.compose.curComponent
    }
  }
}
</script>
